'use strict';

/**
 * Created by jcrid01 on 6/16/15.
 */
var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {
  /**
   * @param params.passcode The passcode you wish to set
   * @param params
   */
  setPasscode: function setPasscode(params) {
    var qs = this.pullQueryStringParams(params);
    return this.postApiRequest(this.getUrl().passcodeNew, qs, params);
  },
  /**
   * @param params.passcode The passcode you wish to verify
   * @param params
   */
  verifyPasscode: function verifyPasscode(params) {
    var qs = this.pullQueryStringParams(params);
    return this.postApiRequest(this.getUrl().passcodeVerify, qs, params);
  },
  /**
   * @param params.passcode The new passcode
   * @param params.oldPasscode The old passcode
   * @param params
   */
  updatePasscode: function updatePasscode(params) {
    var qs = this.pullQueryStringParams(params);
    return this.postApiRequest(this.getUrl().passcodeUpdate, qs, params);
  },
  /**
   * @param params.password The user's account password
   * @param params
   */
  resetPasscode: function resetPasscode(params) {
    var qs = this.pullQueryStringParams(params);
    return this.postApiRequest(this.getUrl().passcodeReset, qs, params);
  },
  /**
   * @param params.passcode The user's passcode
   * @param params
   */
  removePasscode: function removePasscode(params) {
    var qs = this.pullQueryStringParams(params);
    return this.postApiRequest(this.getUrl().passcodeRemove, qs, params);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/passcodeServiceClient.js
// module id = 771
// module chunks = 0